import { Model } from "@ofqual/portal-core/core/types";

export type InformationRequest = {
  id: string;
  requestType: number | null;
  requestSubType: number | null;
  subject: string;
  message: string;
  allowAoReassignment: boolean;
  status: InformationRequestStatus;
  createdByUpn: string;
  createdByDisplayName: string;
  createdDate: string;
  modifiedByUpn: string;
  modifiedByDisplayName: string;
  modifiedDate: string;
  visibleToAllStaff: boolean;
  permissions: string[];
  resourceTags: number[];
  firstRecipientId?: number;
  isSendToMultiple?: boolean;
  minDueDate?: string;
  aoStatus?: string;
};

export enum InformationRequestStatus {
  New = 0,
  Draft = 1,
  Sent = 2,
}

export const fromApiModel = (model: Model): InformationRequest => {
  return {
    ...model,
  } as InformationRequest;
};

export const toApiModel = (item: InformationRequest): Model => {
  return {
    ...item,
  } as Model;
};
